<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke :selectorPermissions="selectorPermissions" v-on:osvezitevIzbranihPodatkovStranke="GetStranka" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div class="postavitev-info-podatkov">
          <p class="open-sans-30pt">
            Prostor v oblaku Horizont
          </p>
          <div style="padding-top: 20px">
            <p class="navadno-besedilo">
              Horizont je vaš oblak za shranjevanje dokumentov, slik in video posnetkov.
              <br/>
              Do prostora v oblaku lahko dostopate preko
              <a :href="povezavaHorizontSpletnaStran" class="primarna-barva" target="_blank">
                spletnega vmesnika</a>.
              S funkcijo Avditorij lahko izbrane vsebine delite tudi na TV vmesniku.
              <br/>
              Več o Horizontu na
              <a :href="povezavaProstorVOblaku" class="primarna-barva" target="_blank">
                www.t-2.net/horizont
              </a>
            </p>
          </div>
          <div v-if="zasedenProstor !== null" class="postavitev-zasedenost-prostora">
            <p class="primarna-barva-pisave">
              Trenutna zasedenost prostora:
              <span>
                <b class="obarvaj-obstojec-narocen-paket" v-loading="pridobivanjeZasedenostiProstora">
                  {{ zasedenProstor }}
                </b>
              </span>
            </p>
          </div>
        </div>
        <div class="postavitev-hramba" v-loading="nalaganjePaketov" style="padding-top: 20px">
          <div class="postavitev-podatkov-hramba" v-for="posamezenPaket in seznamMoznihStoritev">
            <div>
              <div class="postavitev-naziva">
                <b>
                  {{ posamezenPaket.naziv.toUpperCase() }}
                </b>
              </div>
              <div class="podcrtan-naziv">
              </div>
              <div class="izpis-cena-hramba">
                {{ posamezenPaket.cena }} € / mesec
              </div>
              <div>
                <el-col>
                  <div>
                    <div v-if="posamezenPaket.vklopljeno === 1 && koncanoPridobivanjePodatkov === 1"
                         class="izpis-naroceno">
                      <span style="padding-top: 50px">
                        <img src="/static/img/kljukica2.svg"/>
                      </span>
                      NAROČENO
                    </div>
                    <div class="postevitev-gumba-paket">
                      <OrderButton
                        v-if="posamezenPaket.dovoljenaIzbira === 1 && posamezenPaket.naroceno === 0 && posamezenPaket.vklopljeno !== 1 && izbranIdStranka !== ''"
                        :services="[{serviceId: posamezenPaket.idStoritevVrstaIzbira, quantity: 1, customerId: Number.parseInt(izbranIdStranka)}]"
                        class="postavitev-gumb-narocanje"
                        :service-name="posamezenPaket.naziv"
                        style="width: 92px;"
                        @orderConfirmed="GetSeznamPaketov"
                      >
                        NAROČI
                      </OrderButton>
                      <OrderButton
                        v-if="posamezenPaket.vklopljeno === 1 && koncanoPridobivanjePodatkov === 1 && izbranIdStranka !== ''"
                        :services="[{serviceId: posamezenPaket.idStoritevVrstaIzbira, quantity: 0, customerId: Number.parseInt(izbranIdStranka)}]"
                        class="postavitev-gumb-narocanje"
                        :service-name="posamezenPaket.naziv"
                        @orderConfirmed="GetSeznamPaketov"
                      >
                        ODJAVI HORIZONT
                      </OrderButton>
                    </div>
                    <div v-if="posamezenPaket.dovoljenaIzbira === 0 && posamezenPaket.vklopljeno === 0"
                         class="postevitev-gumba-paket">
                      <el-button class="gumb-ni-na-voljo sirina-gumba-ni-na-voljo"
                        style="display: flex; justify-content: center;">
                        <b>
                          NI NA VOLJO
                        </b>
                      </el-button>
                    </div>
                    <div v-if="posamezenPaket.naroceno === 1 && koncanoPridobivanjePodatkov === 1"
                         class="postevitev-gumba-paket">
                      <a class="okvir-narocilo-v-teku vsebina-naroceno"
                         style="display: flex; justify-content: center;">
                        <b>
                          NAROČILO V TEKU
                        </b>
                      </a>
                    </div>
                  </div>
                </el-col>
              </div>
            </div>
          </div>
        </div>
        <div class="postavitev-info">
          <div class="info-okvir">
            <div class="postavitev-info-icone">
              <i class="fa fa-info-circle"></i>
            </div>
            <div class="postavitev-info-tekst">
              <p class="modra-barva-info">
                Za naročilo manjšega zakupa prostora, je potrebno najprej izbrisati vsebine in
                zmanjšati skupno zasedenost prostora na strežniku.
              </p>
            </div>
          </div>
        </div>
        <OrderExistsInfo v-if="hasAnyPendingOrder"/>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {povezave} from '../../../../assets/js/Povezave/povezave'
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import {PretvorbaEnot} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import {
  Select, Option, Form, Button, Tooltip, CollapseItem, Collapse,
  Col
} from 'element-ui'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke'
import OrderButton from '../../../UIComponents/OrderButton.vue'
import OrderExistsInfo from '../../../UIComponents/OrderExistsInfo.vue'

export default {
  name: 'NarociHramba',
  mixins: [PretvorbaEnot, GetPodatkiIzbirnika],
  data () {
    return {
      clientAgent: null,
      seznamMoznihStoritev: [],
      seznamStoritev: [],
      vklopljenHorizont: null,
      narocenHorizont: null,
      koncanoPridobivanjePodatkov: 0,
      nalaganjePaketov: false,
      zasedenProstor: 0,
      izbranIdStranka: '',
      pridobivanjeZasedenostiProstora: false,
      povezavaHorizontPortal: '',
      povezavaHorizontSpletnaStran: '',
      povezavaProstorVOblaku: '',
      selectorPermissions: ['STRANKE']
    }
  },
  components: {
    OrderButton,
    OrderExistsInfo,
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    'IzbirnikStranke': IzbirnikStranke,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Col.name]: Col
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.povezavaHorizontPortal = povezave.BASE_URL_HORIZONT_PORTAL
    this.povezavaHorizontSpletnaStran = povezave.BASE_URL_HORIZONT_PORTAL
    this.povezavaProstorVOblaku = povezave.BASE_URL_PROSTOR_V_OBLAKU
  },
  methods: {
    GetStranka (podatkiStranke) {
      if (podatkiStranke.id_stranka !== null && podatkiStranke.id_stranka_sap !== null) {
        this.izbranIdStranka = podatkiStranke.id_stranka
        this.izbranaStrankaSap = podatkiStranke.id_stranka_sap
        this.GetSeznamPaketov()
        this.GetPorabaProstora()
      }
    },
    GetPorabaProstora () {
      if (this.izbranIdStranka !== '') {
        this.pridobivanjeZasedenostiProstora = true
        let param = ['idStranka=' + this.izbranIdStranka]
        this.clientAgent.postWsRequest(
          this,
          'stranka/storitve/porabaProstoraInfo',
          param,
          null,
          'SetPorabaProstora',
          'ErrPorabaProstora')
      }
    },
    SetPorabaProstora (podatki) {
      let pretvorbaZasedenostiProstora = 0
      pretvorbaZasedenostiProstora = this.PretvoriKolicinoVPrijaznoOblikoB(podatki.data.skupaj)
      this.zasedenProstor = pretvorbaZasedenostiProstora
      this.pridobivanjeZasedenostiProstora = false
    },
    ErrPorabaProstora (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetSeznamPaketov () {
      this.nalaganjePaketov = true
      this.koncanoPridobivanjePodatkov = 0
      if (this.izbranIdStranka !== '') {
        let param = ['idStranka=' + this.izbranIdStranka]
        param.push('idVrsta[]= 103')
        this.clientAgent.postWsRequest(
          this,
          'stranka/storitve/getNaborStoritevHorizonta',
          param,
          null,
          'SetSeznamPaketov',
          'ErrSeznamPaketov')
      }
    },
    SetSeznamPaketov (podatki) {
      this.seznamMoznihStoritev = podatki.data
      for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
        Vue.set(this.seznamMoznihStoritev[i], 'naroceno', 0)
        Vue.set(this.seznamMoznihStoritev[i], 'vklopljeno', 0)
      }
      this.GetVklopljeneStoritve()
    },
    ErrSeznamPaketov (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetVklopljeneStoritve () {
      if (this.izbranIdStranka !== '') {
        let param = ['idStranka=' + this.izbranIdStranka]
        param.push('idVrsta[]= 103')
        param.push('idStatus=1')
        this.clientAgent.postWsRequest(
          this,
          '/stranka/storitve/info',
          param,
          null,
          'SetTrenutnoIzbraneStoritve',
          'ErrTrenutnoIzbraneStoritve')
      }
    },
    SetTrenutnoIzbraneStoritve (podatki) {
      this.vklopljenHorizont = null
      if (podatki.seznamStoritev.length > 0) {
        for (let i = 0; i < podatki.seznamStoritev.length; i++) {
          if (podatki.seznamStoritev[i].idVrsta === 103) {
            this.vklopljenHorizont = podatki.seznamStoritev[i]
            for (let j = 0; j < this.seznamMoznihStoritev.length; j++) {
              if (this.seznamMoznihStoritev[j].idStoritevVrstaIzbira === this.vklopljenHorizont.idStoritev) {
                Vue.set(this.seznamMoznihStoritev[j], 'vklopljeno', 1)
              }
            }
            break
          }
        }
      }
      this.GetNaroceneStoritve()
    },
    ErrTrenutnoIzbraneStoritve (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetNaroceneStoritve () {
      if (this.izbranIdStranka !== '') {
        let param = ['idStranka=' + this.izbranIdStranka]
        param.push('idVrsta[]= 103')
        param.push('idStatus=0')
        this.clientAgent.postWsRequest(
          this,
          'stranka/storitve/info',
          param,
          null,
          'SetTrenutnoNaroceneStoritve',
          '')
      }
    },
    SetTrenutnoNaroceneStoritve (podatki) {
      this.narocenHorizont = null
      if (podatki.seznamStoritev.length > 0) {
        for (let i = 0; i < podatki.seznamStoritev.length; i++) {
          if (podatki.seznamStoritev[i].idVrsta === 103) {
            this.narocenHorizont = podatki.seznamStoritev[i]
          }
        }
        for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
          Vue.set(this.seznamMoznihStoritev[i], 'naroceno', 0)
        }
        for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
          if (this.seznamMoznihStoritev[i].idStoritevVrstaIzbira === this.narocenHorizont.idStoritev) {
            Vue.set(this.seznamMoznihStoritev[i], 'naroceno', 1)
            break
          }
        }
      }
      this.koncanoPridobivanjePodatkov = 1
      this.nalaganjePaketov = false
    }
  },
  computed: {
    hasAnyPendingOrder () {
      let out = false
      if (Array.isArray(this.seznamMoznihStoritev)) {
        this.seznamMoznihStoritev.forEach((item) => {
          if (item.naroceno === 1) {
            out = true
          }
        })
      }
      return out
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Naroci/NarociHramba/NarociHramba.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociHramba.vue